/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Custom code to display product qty on product pg

var sections = window.theme.sections;
var inventorySelectorHtml = '.inventoryWrapper';
var productExtension = {
  init: function() {
      this.on('variant_change_successful', this._updateInventory.bind(this));
      this.on('variant_change_undefined', this._removeInventory.bind(this));
  },
  _removeInventory: function() {
    $(inventorySelectorHtml, this.container).html('');
  },
  _updateInventory: function(event, instance, product, variant) {
    if (variantStock[variant.id] > 0 && variant.inventory_management == 'shopify') {
      $(inventorySelectorHtml, this.container).html(`<p>Available Stock: ${variantStock[variant.id]} of 13</p>`);
    } else {
      $(inventorySelectorHtml, this.container).html('');
    }
  }
};
sections.extend('product-template', productExtension);
sections.extend('featured-product', productExtension);